import "react-responsive-carousel/lib/styles/carousel.min.css";
import Header from "./Header";
import Footer from "./Footer";
import CenterMode from "./CenterMode";
import SlickSlider from "./SlickerSlider";
function Services() {
  return (
    <>
      <Header />
      <section id="rapid-services"></section>
      <section id="our-services" className="  w-100 h-100 ">
        <div className="">
          <h2 className="text-center text-primary-emphasis pt-3 fw-semibold">
            {" "}
            Our Services
          </h2>
          <p className="fw-semibold px-5 fs-6 col-sm-12 col-md-12 col-lg-8 text-center mx-auto text-primary-emphasis ">
            <strong className="text-primary-emphasis">RAPID LAB-</strong> Our
            state-of-the-art medical facility which uses ultra-modern equipment
            and the latest technology to provide a comprehensive range of
            emergency, routine, and specialized laboratory tests. We provide the
            best medical expertise that are competent and trusted, skilled and,
            experience in various disciplines including:
          </p>
          {/* carousel for services */}

          <div>
            <div className="container mt-5 ">
              <div
                id="imageCarousel"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img
                      loading="lazy"
                      src="images/assets/immunology and serology .jpg"
                      className="d-block w-100"
                      alt="..."
                    />
                    <div className="carousel-caption-custom">
                      <h5>
                        {" "}
                        <li>Immunology and serology</li>
                      </h5>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img
                      loading="lazy"
                      src="images/assets/molecular_biology_1.jpg"
                      className="d-block w-100"
                      alt="..."
                    />
                    <div className="carousel-caption-custom">
                      <h5>
                        <li>Molecular Biology</li>
                      </h5>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img
                      loading="lazy"
                      src="images/assets/biochemistry1.jpg"
                      className="d-block w-100"
                      alt="..."
                    />
                    <div className="carousel-caption-custom">
                      <h5>
                        <li>Biochemistrty</li>
                      </h5>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img
                      loading="lazy"
                      src="images/assets/Haematology1.jpg"
                      className="d-block w-100"
                      alt="..."
                    />
                    <div className="carousel-caption-custom">
                      <h5>
                        <li>Haematlogy</li>
                      </h5>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img
                      loading="lazy"
                      src="images/assets/parasitology.jpg"
                      className="d-block w-100"
                      alt="..."
                    />
                    <div className="carousel-caption-custom">
                      <h5>
                        <li>Parasitology</li>
                      </h5>
                    </div>
                  </div>

                  <div className="carousel-item">
                    <img
                      loading="lazy"
                      src="images/assets/andrology.jpg"
                      className="d-block w-100"
                      alt="..."
                    />
                    <div className="carousel-caption-custom">
                      <h5>
                        <li>Andrology</li>
                      </h5>
                    </div>
                  </div>
                </div>

                {/* <!-- Controls --> */}
                <button
                  className="carousel-control-prev"
                  type="button"
                  data-bs-target="#imageCarousel"
                  data-bs-slide="prev"
                >
                  <span className="carousel-control-prev-icon"></span>
                </button>
                <button
                  className="carousel-control-next"
                  type="button"
                  data-bs-target="#imageCarousel"
                  data-bs-slide="next"
                >
                  <span className="carousel-control-next-icon"></span>
                </button>
              </div>
            </div>
          </div>
          {/* <!--  PRECAUTIONARY HEALTH CHECKUP SERVICES --> */}
          <div>
            <h3 className="text-primary-emphasis  text-center pt-3 ">
              RAPID SCREEN & DIAGNOSTICS PRECAUTIONARY HEALTH CHECKUP SERVICES
            </h3>
            <div className="d-flex justify-content-center align-items-center">
              <img
                loading="lazy"
                src="images/assets/health-service.png"
                className=" rounded-2 fly-in-top "
                alt="..."
                style={{ width: "420px" }}
              />
            </div>
            <p className="fs-6 fw-semibold text-start mx-auto col-sm-12 col-md-12 col-lg-8 container text-primary-emphasis">
              An in-depth health checkup is the best and safest way to discover
              most medical conditions and treat them. Early diagnostics and
              screen helps detect disease and help in the management and
              treatment of the various condition to reduces the risk of
              complications. We offer an in-depth health checkup Health checkup
              can result in you our cherished customers deciding to make
              positive improvements in your lives. Rapid provide the prime
              health checkup packages to help you make lifestyle changes that
              can impact your health and up to date recommendation. We believe
              that with regular health checkups and lifestyle change, we are
              more informed about the condition of our bodies, the
              irregularities involved and the efforts we will have to make
              towards avoiding severe health issues and keeping track of our
              health. Our health check packages are designed to strategically
              assess your overall health and our reports can act as a blueprint
              to your health, showing you where you are now and where to focus,
              and we recommend sharing with your physician.
            </p>
          </div>
          {/* <!--  MOBILE CONCIERGE & DRIVE-THROUGH PHLEBOTOMY SERVICES --> */}
          <div className="pt-3 ">
            <h3 className="text-primary-emphasis fs-3 text-center mx-auto col-lg-8 ">
              MOBILE CONCIERGE & DRIVE-THROUGH PHLEBOTOMY
            </h3>
            <div className="d-flex justify-content-center align-items-center ">
              <img
                loading="lazy"
                src="images/assets/mobile-concierge.jpeg"
                className=" rounded-2  fly-in-top"
                alt="..."
                style={{ width: "420px" }}
              />
            </div>
            <p className="fs-6 fw-semibold text-start mx-auto col-sm-12 col-md-12  col-lg-8 mx-auto text-primary-emphasis">
              An in-depth health Rapid Lab’s certified team phlebotomists who
              are on standby to help you whenever you need blood draw in the
              comfort of your home, office or hospital ward and a drive through
              service where you can visit our parking site and sit in the
              comfort your car to be attended to. Your specimen will be
              delivered to our laboratory with care, timely and professionally.
              Our mobile & Drive-through phlebotomy service is a convenient,
              safe, professional, confidential and cost-effective choice you can
              trust. Kindly select what best represents you or your
              organization.
            </p>
            <SlickSlider />
          </div>
        </div>

        {/* <!-- Carousel --> */}
        <div className="pt-0 rounded-4 bg-services">
          <div>
            <CenterMode />
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Services;
